<template>
    <div class="home">
        <x-header back v-if="!isShowHeader">{{type!='1'?'成员管理':'成员信息'}}</x-header>
        <x-content v-if="loading" style="height:100%;" :contentStyle="{alignItems:'center',justifyContent:'center',height:'100%'}">
            <bounce-loading></bounce-loading>
        </x-content>
        
        <x-content v-else  :contentStyle="{display:'block',width:'calc(100% - 32px)',padding:'16px'}">
			<div class="search_warp">
				<el-row class="list-control_warp">
					<el-col :span="5">
						   <el-input alwaysShowClear clearable v-model="searchText" @keydown.enter.native="search" placeholder="输入成员名字">
                        <template slot="suffix">
                            <i @click="search" style="cursor: pointer;" class="el-input__icon base-icon-search"></i>
                        </template>
                    </el-input>
					</el-col>
					<div style="display: flex; justify-content: flex-end;" v-if="type!='1'">
                        <el-button size="medium" class="btnInfo" @click="openInviteUser" icon="el-icon-circle-plus-outline">
                            <span> 邀请成员</span>
                        </el-button>
                        <el-button size="medium" type="primary" @click="openDialog" icon="base-icon-plus">
                            <span> 新增成员</span>
                        </el-button>
					</div>
				</el-row>
			</div>
            <x-card>
                <el-table
                    :data="groupDataList"
                    ref="groupUserSelect"
                    stripe
                    style="width: 100%">
                    <el-table-column
                        label="成员名称">
                        <template slot-scope="scope">
                            <div class="groupUser_avatar_info">
                               <!--  <div class="avatar">
                                    <svg v-if="scope.row.role==GROUP_ROLE.LEADER" t="1668739741074" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10769" width="32" height="32"><path d="M525.486829 289.017756c13.886439-5.394732 23.576976-18.781659 23.576976-34.566244 0-20.48-16.683707-36.963902-37.063805-37.063805-20.48 0-36.963902 16.683707-36.963902 37.063805 0 15.684683 9.790439 29.171512 23.676878 34.566244l13.386926-33.966829 13.386927 33.966829zM126.476488 478.033171c7.39278-6.793366 11.988293-16.483902 11.988292-27.273366 0-20.48-16.583805-36.963902-37.063804-36.963903s-36.963902 16.583805-36.963903 36.963903c0 20.48 16.583805 36.963902 36.963903 36.963902 5.994146 0 11.688585-1.398634 16.683707-3.896195l-6.193951-14.585756 14.585756 8.791415zM232.273171 762.65522h559.553561v43.957073H232.273171z" p-id="10770" fill="#f4ea2a"></path><path d="M732.085073 577.336195l-1.798244-180.823415c-2.797268-0.299707-5.594537-0.999024-8.192-1.898146l-101.900488 135.367805L525.486829 289.017756c-4.096 1.598439-8.59161 2.497561-13.386927 2.497561-4.695415 0-9.191024-0.899122-13.386926-2.497561l-94.707513 240.964683-101.900487-135.367805c-2.597463 0.899122-5.294829 1.598439-8.192 1.898146l-1.798244 180.823415-165.738147-99.303024c-2.497561 2.297756-5.294829 4.195902-8.391805 5.794341l115.08761 268.337951h557.655415l115.08761-268.437853c-2.997073-1.498537-5.794341-3.496585-8.291903-5.794342l-165.438439 99.402927z m-148.754732 30.869854l-21.578926 19.780683c-5.794341 5.294829-9.390829 16.184195-7.692488 23.876683l5.794341 28.771902c1.498537 7.692488-2.697366 10.889366-9.690536 6.993171l-25.475122-14.385951c-6.893268-3.896195-18.182244-3.896195-25.175415 0l-25.475122 14.485853c-6.893268 3.896195-11.288976 0.699317-9.690536-6.99317l5.794341-28.771903c1.498537-7.79239-1.898146-18.481951-7.692488-23.876683l-21.578927-19.780683c-5.794341-5.294829-4.195902-10.489756 3.696391-11.388878l29.071609-3.29678c7.79239-0.999024 17.083317-7.592585 20.280196-14.685659l12.088195-26.673951c3.29678-7.192976 8.691512-7.192976 11.988292 0l12.088195 26.673951c3.29678 7.192976 12.487805 13.886439 20.280196 14.685659l29.071609 3.29678c8.092098 0.899122 9.690537 5.994146 3.896195 11.288976z" p-id="10771" fill="#f4ea2a"></path><path d="M730.286829 396.51278c1.398634 0.199805 2.897171 0.299707 4.395708 0.299708 20.579902 0 37.063805-16.583805 37.063804-37.063805s-16.683707-36.963902-37.063804-36.963903-36.963902 16.583805-36.963903 36.963903c0 15.98439 10.190049 29.671024 24.476098 34.865951l7.992195-10.689561 0.099902 12.587707zM302.104976 394.614634c14.186146-5.194927 24.376195-18.781659 24.376195-34.865951 0-20.48-16.583805-36.963902-36.963903-36.963903-20.579902 0-37.063805 16.583805-37.063805 36.963903s16.483902 36.963902 37.063805 37.063805c1.498537 0 2.997073-0.099902 4.49561-0.299708l0.099902-12.587707 7.992196 10.689561zM922.698927 413.795902c-20.48 0-36.963902 16.583805-36.963903 36.963903 0 10.789463 4.595512 20.48 11.888391 27.173463l14.485853-8.691512-6.193951 14.485854c4.995122 2.597463 10.689561 3.996098 16.78361 3.996097 20.48 0 36.963902-16.483902 36.963902-36.963902s-16.583805-36.963902-36.963902-36.963903z" p-id="10772" fill="#f4ea2a"></path></svg>
                                    <el-avatar :size="50" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
                                </div>
                                -->
                                <span style="margin-left:10px;">{{scope.row.userName}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="角色">
                        <template slot-scope="scope">
                            <span v-if="scope.row.role">{{SHOW_GROUP_ROLE[scope.row.role]}}</span>
                        </template>
                    </el-table-column>
                    
                    <el-table-column
                        label="邮箱">
                        <template slot-scope="scope">
                            <span v-if="scope.row.user.email">{{scope.row.user.email}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="手机">
                        <template slot-scope="scope">
                            <span v-if="scope.row.user.mobile">{{scope.row.user.mobile}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        width="240px"
                        v-if="type!='1'"
                        label="操作">
                        <template slot-scope="scope">
                                <el-link class="group_operate" :underline="false" @click="deleteGroupUser(scope.row)" type="primary" v-if="scope.row.userId!=user.id">移出成员</el-link>
                                <el-link class="group_operate"  v-if="!scope.row.role.includes('2')" :underline="false" @click="setManager(scope.row,GROUP_ROLE.MANAGER)" type="primary">设为负责人</el-link>
                                <el-link class="group_operate" v-if="scope.row.role.includes('2')" :underline="false" @click="cancelManager(scope.row,GROUP_ROLE.USER)" type="primary">取消负责人</el-link>
                                <el-link class="group_operate" v-if="!scope.row.role.includes('4')" :underline="false" @click="setReview(scope.row,GROUP_ROLE.REVIEW)" type="primary">设为复核人</el-link>
                                <el-link class="group_operate" v-if="scope.row.role.includes('4')"  :underline="false" @click="cancelReview(scope.row,GROUP_ROLE.USER)" type="primary">取消复核人</el-link>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page-warp">
                    <el-pagination
                        @current-change="listGroupUser"
                        :hide-on-single-page="total<pageSize"
                        background
                        layout="total,prev, pager, next"
                        :total="total"
                        :page-size="pageSize"
                        :current-page.sync="page"
                    ></el-pagination>
                </div>
            </x-card>
        </x-content>
      <app-dialog  ref="inviteUserDialog" dialogTitle="邀请成员" originTitle staticDialog width="600px">
        <div>
          <el-form >
            
            <el-form-item  v-model="inviteEmail">
              <el-input  v-model="inviteEmail" placeholder="请输入邮箱"></el-input>
            </el-form-item>
            <div class="save_btn_warp">
              <el-button type="primary" @click="inviteUser" style="width:200px;" size="medium" :loading="saveLoading">确定</el-button>
            </div>
          </el-form>
        </div>
      </app-dialog>
        <app-dialog  ref="addDialog" dialogTitle="新增成员" originTitle staticDialog width="700px">
            <div style="display: flex;justify-content: center;">
                <el-transfer
                    filterable
                    :filter-method="filterMethod"
                    filter-placeholder="请输入名字查询"
                    :titles="['未加入的成员', '已加入的成员']"
                    v-model="checkUserData"
                    :data="userToAddGroup">
                </el-transfer>
            </div>
            <div class="save_btn_warp">
                <el-button type="primary" style="width:100px" size="medium" :loading="saveLoading" @click="saveBatchGroupUser">保存</el-button>
            </div>
        </app-dialog>
    </div>
</template>
<script>
import {
  Update,
  GetGroupUser,
  GetGroupById,
  GetAllUserToAddGroup,
  SaveOrUpdateList,
  RemoveById,
  GetManageNum,
  GetUserDetails,
  InviteUser
} from "../../service/user"
    export default {
        name:'RoleManager',
        mixins:[],
        props: {
        isShowHeader: Boolean
        },
        data(){
            return {
                loading:false,
                saveLoading:false,
                groupData:{},
                researchDeptArr:[],
                topicGroupArr:[],
                page:1,
                total:0,
                pageSize:10,
                searchText:"",
                groupDataList:[],
                checkRoleId:'',
                userToAddGroup:[],
                checkUserData:[],
                addGroupUserMap:{},
                allUserIdNameMap:{},
                selectTableUser:[],
                noEdit:false,
                user:{},
                inviteEmail:'',
                type:"",
            }
        },
        created(){
             this.groupId = this.$route.params.groupId || '';
              this.type = this.$route.params.type || '';
           this.getData();
        },
        methods:{
          getUserData(data){
            this.groupId=data;
            this.getData();
          },
            getData(){
              this.getGroupById();
                this.listGroupUser();
                this.getUser();
            },
            search() {
				this.page = 1;
				this.listGroupUser();
			},
            inviteUser(){
                if (!this.inviteEmail) {
                this.$message.warning("请输入待邀请的成员邮箱");
                return false;
              }
              var patten = /^([a-zA-Z0-9]+[_|_|\-|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
              if (!patten.test(this.inviteEmail)) {
                this.$message("请输入正确的邮箱格式");
                return false;
              } else {
                InviteUser(this.groupId,this.inviteEmail,this.groupData.groupName).then(e => {
                  let data = this.APIParse(e);
                  if(data){
                    this.$message.success("邀请成员成功")
                    this.$refs['inviteUserDialog'].hide()
                    this.listGroupUser();
                  }
                }).catch(e => {
                  this.$message.error(e.message)
                }).finally(e => {
                })
              }
            },
            openInviteUser(){
                this.inviteEmail="";
              this.$refs['inviteUserDialog'].show()
            },
            getGroupById(){
                GetGroupById(this.groupId).then(e => {
                    let data = this.APIParse(e);
                    this.groupData = data;
                    if(data.archivingStatus==1||(data.userRole&&(data.userRole.includes('3')))){
                        this.type='1'
                    }
                })
            },
            openDialog(){
                this.userToAddGroup = [];
                GetAllUserToAddGroup().then(e => {
                    let data = this.APIParse(e);
                    data.forEach(item =>{
                        this.allUserIdNameMap[item.id] = item.name
                    })
                    this.userToAddGroup = data.map(item => {
                        return {"label":item.name,"key":item.id,"disabled":this.addGroupUserMap[item.id]?true:false};
                    })
                })
                this.$refs['addDialog'].show()
            },
            filterMethod(query, item) {
                return item.label.indexOf(query) > -1;
            },
            getUser() {
              GetUserDetails().then(e => {
                this.user = e.data;
              }).catch(e => {
                this.$message.error(e.message)
              }).finally(e => {

              })
            },
            listGroupUser(page){
                this.addGroupUserMap = {};
                this.loading = true;
                GetGroupUser(this.groupId,this.searchText,this.page,this.pageSize).then(e => {
                    let data = this.APIParse(e);
                    this.groupDataList = data.records;
                    this.checkUserData = data.records.map(item => {return item.userId})
                    data.records.forEach(item => {
                        this.addGroupUserMap[item.userId] = item;
                    })
                    this.total = data.total || 0
                }).catch(e => {
                    this.$message.error(e.message)
                }).finally(e => {
                    this.loading = false;
                })
            },
            saveBatchGroupUser(){
                this.$confirm('确定添加这些成员到该项目么', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let groupUserRelationList = [];
                    if(this.checkUserData.length>0){
                        this.checkUserData.forEach(userId => {
                            if(this.addGroupUserMap[userId]){
                                // groupUserRelationList.push(this.addGroupUserMap[e])
                            }else{
                                groupUserRelationList.push({
                                    "role":"3","userId":userId,"groupId":this.groupId,"userName":this.allUserIdNameMap[userId]
                                })
                            }
                        })
                    }
                    SaveOrUpdateList(groupUserRelationList).then(e => {
                        let data = this.APIParse(e);
                        if(data){
                            this.$message.success("添加成员成功")
                            this.$refs['addDialog'].hide()
                            this.listGroupUser();
                        }
                    }).catch(e => {
                        this.$message.error(e.message)
                    }).finally(e => {
                    })
                }).catch(() => {  
                });
            },
            setManager(row,role){
                 this.$confirm('确定把'+row.userName+'设为负责人么？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                     if (row.role!=3){
                       row.role = role+row.role
                     }else {
                       row.role=role
                     }
                    Update(row).then(e => {
                        let data = this.APIParse(e);
                        if(data){
                            this.$message.success("负责人设置成功")
                            this.listGroupUser();
                        }
                    }).catch(e => {
                        this.$message.error(e.message)
                    }).finally(e => {
                    })

                }).catch(() => {  
                });
            },
            cancelManager(row,role){
                 this.$confirm('确定取消'+row.userName+'的负责人角色么？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    GetManageNum(this.groupId).then(e => {
                    if(e.data>1){
                        if (row.role.includes('2')) {
                            row.role = row.role.replace('2', '');
                        }
                        if (row.role==''){
                            row.role='3'
                        }
                        Update(row).then(e => {
                            let data = this.APIParse(e);
                            if(data){
                                this.$message.success("负责人取消成功")
                                this.listGroupUser();
                            }
                        }).catch(e => {
                            this.$message.error(e.message)
                        })
                    }else{
                        this.$message.warning(row.userName+"是项目唯一负责人，需先指定其他用户为项目负责人，再进行操作")
                        return
                    }
                })
                  

                }).catch(() => {  
                });
            },
          setReview(row,role){
            this.$confirm('确定把'+row.userName+'设为复核人么？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              if (row.role!=3){
                row.role = role+row.role
              }else {
                row.role=role
              }
              // row.role = role
              Update(row).then(e => {
                let data = this.APIParse(e);
                if(data){
                  this.$message.success("复核人设置成功")
                  this.listGroupUser();
                }
              }).catch(e => {
                this.$message.error(e.message)
              }).finally(e => {
              })

            }).catch(() => {
            });
          },
          cancelReview(row,role){
            this.$confirm('确定取消'+row.userName+'的复核人角色么？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              if (row.role.includes('4')) {
                row.role = row.role.replace('4', '');
              }
              if (row.role==''){
                row.role='3'
              }
              Update(row).then(e => {
                let data = this.APIParse(e);
                if(data){
                  this.$message.success("复核人取消成功")
                  this.listGroupUser();
                }
              }).catch(e => {
                this.$message.error(e.message)
              }).finally(e => {
              })

            }).catch(() => {
            });
          },
            deleteGroupUser(row){
                this.$confirm('确定把'+row.userName+'移出该项目么？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    row.role = '负责人'
                    RemoveById(row.id).then(e => {
                        let data = this.APIParse(e);
                        if(data){
                            this.$message.success("移出成功")
                            this.listGroupUser();
                        }
                    }).catch(e => {
                        this.$message.error(e.message)
                    }).finally(e => {
                    })

                }).catch(() => {  
                });
            }
        }
    }
</script>
<style lang="scss" scoped>
    .group_operate+.group_operate{
        margin-left: 10px;
    }
    .Width-100{width: 100%}
    .home{width: 100%;height: 100%;overflow: auto;}
    .search_warp{width:100%;margin: 16px 0px;}
    
    .save_btn_warp{width: 100%;margin-top: 32px;display: flex;align-items: center;justify-content: center;}
    .group_info{
        padding-left: 16px;
        display: flex;
        align-items: center;
        // justify-content: space-between;
    }
    .group_info span+span{
       margin-left: 150px;
    }
    .page-warp{
        text-align: center;
        margin-top: 20px;
    }
    .operate_search{
        margin-bottom: 20px;
    }
    .groupUser_avatar_info{
        display: flex;
        align-items: center;
    }
    .control_operate{
        display: flex;
        justify-content: space-between;
    }
    .groupUser_avatar_info .avatar{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .setTooltip{
        margin-top: 30px;
        color:#409eff
    }
</style>